/* eslint-disable no-unused-vars */
import { MoreVertical, RotateCw } from 'lucide-react'
import { useContext } from 'react'
import { Button, Col, Container, Dropdown, Navbar, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { UserContext } from '../../context/userContext'
import '../../styles/style.css'

const NavbarMover = ({ user }) => {
  const navigate = useNavigate()
  const [state, dispatch] = useContext(UserContext)

  const handleLogOut = () => {
    Swal.fire({
      title: 'Sign Out?',
      icon: 'warning',
      iconColor: '#828282',
      showCancelButton: true,
      confirmButtonColor: '#C12727',
      cancelButtonColor: 'transparent',
      confirmButtonText: 'Sign out',
      showCloseButton: true,
      customClass: {
        title: 'swal-title-outbound',
        popup: 'swal-popup-outbound',
        actions: 'swal-remove-outbound'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch({ type: 'logout', payload: '' })
        navigate('/')
      }
    })
  }

  const handleRefresh = async () => {
    window.location.reload()
  }

  return (
    <>
      <Navbar
        className="bg-white py-3 sticky-top"
        style={{
          boxShadow: '0 4px 20px -5px rgba(0, 0, 0, 0.05)',
          borderBottom: '1px solid rgba(0,0,0,0.02)',
          zIndex: 1030
        }}
      >
        <Container>
          <Row className="w-100 align-items-center m-0">
            <Col className="p-0">
              <Navbar.Brand href="#home" className="d-flex align-items-center">
                <div className="d-flex flex-column">
                  <span
                    className="text-muted"
                    style={{ fontSize: '12px', letterSpacing: '0.5px' }}
                  >
                    Welcome back,
                  </span>
                  <span
                    className="fw-bold text-dark text-capitalize"
                    style={{ fontSize: '18px' }}
                  >
                    {user.username}
                  </span>
                </div>
              </Navbar.Brand>
            </Col>
            <Col className="d-flex justify-content-end p-0">
              <div className="d-flex align-items-center gap-3">
                <Button
                  variant="light"
                  className="rounded d-flex align-items-center justify-content-center border-0 shadow-sm"
                  style={{
                    width: '40px',
                    height: '40px',
                    backgroundColor: '#f8f9fa'
                  }}
                  onClick={handleRefresh}
                >
                  <RotateCw size={16} className="text-secondary" />
                </Button>

                <Dropdown align="end">
                  <Dropdown.Toggle
                    as="div"
                    className="d-flex align-items-center justify-content-center cursor-pointer p-0"
                    style={{ cursor: 'pointer' }}
                    id="dropdown-setting-mover"
                  >
                    <div
                      className="rounded shadow-sm d-flex align-items-center justify-content-center"
                      style={{
                        width: '40px',
                        height: '40px',
                        backgroundColor: '#fff',
                        border: '1px solid #eee'
                      }}
                    >
                      <MoreVertical size={18} className="text-secondary" />
                    </div>
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    className="border-0 shadow-lg p-2"
                    style={{
                      marginTop: '10px',
                      borderRadius: '12px',
                      minWidth: '180px'
                    }}
                  >
                    <Dropdown.Item
                      className="d-flex align-items-center rounded-3 py-2 px-3 text-danger fw-medium"
                      onClick={handleLogOut}
                      style={{ transition: 'all 0.2s' }}
                    >
                      <span className="ms-1">Sign Out</span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Col>
          </Row>
        </Container>
      </Navbar>
    </>
  )
}

export default NavbarMover
